import { memo, useState } from 'react'

import { Box } from '@mui/material'

import { JSON as StatusJson } from './Status'
import { StatusOverview } from './StatusOverview'
import { ViewMode, ViewModeToggle } from './ViewModeToggle'

/** Status tab: Simple read-only overview ⇄ raw JSON. */
const StatusViewRaw = () => {
  const [mode, setMode] = useState<ViewMode>('simple')

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <Box sx={{ px: 3, pt: 2, pb: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <ViewModeToggle mode={mode} onChange={setMode} />
      </Box>
      <Box sx={{ flex: 1, minHeight: 0 }}>{mode === 'simple' ? <StatusOverview /> : <StatusJson />}</Box>
    </Box>
  )
}

export const StatusView = memo(StatusViewRaw)
